import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AddNewCompValidation } from "../../../../../modules/manage-equipment/models/manage-equipment.model";
import { Router } from "@angular/router";
import { AppService } from "../../../../../app.service";

@Component({
  selector: "app-add-new-component-validation",
  templateUrl: "./add-new-component-validation.html",
  styleUrls: ["./add-new-component-validation.scss"],
})
export class AddNewComponentValidationComponent implements OnInit {
  equipmentHistory: AddNewCompValidation[] = [];
  displayedColumns: string[] = [
    "InspDate",
    "SystemSerial",
    "SerialNo",
    "UnitNo",
  ];
  isReplaceExistingTab: boolean = false;
  constructor(
    public _dialogRef: MatDialogRef<AddNewComponentValidationComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _router: Router,
    private _app: AppService,
  ) {}

  ngOnInit(): void {
    this.equipmentHistory = this._data.Data;
    this.isReplaceExistingTab = this._data.IsReplaceExistingTab;
  }
  goAhead() {
    this._dialogRef.close(true);
  }
  cancel() {
    this._dialogRef.close(false);
  }
  openEquipment(equipmentId: number): void {
    const url = `${this._app.getBaseURL()}equipment/${equipmentId}`;
    if (this.isReplaceExistingTab) {
      window.location.href = url;
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
}
}